import React, { useState, useContext, useEffect } from 'react'
import { Button } from '@material-ui/core'
import './Footer.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LOGO, SITE_NAME } from '@/utils'
import { mapData } from '@/product/common/components'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import AuthContext from '@/product/context/auth/authContext'
import CustomDialog from '../../organisms/CustomDialog'
import howToReg from '../../../../assets/How_To_Register.pdf'
import brochurePDF from '../../../../assets/iQuippo_Brochure.pdf'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import MobileBottomNavigation from '../MobileNavigation'
import commonContext from '@/custom/context/common/commonContext'

const Footer = () => {
    const autopltContext = useContext(AutopltContext)
    const { t } = useTranslation()
    const { addCustomer, responseStatus: responseStatusAutoPlt } = autopltContext
    const [toggleSeller, setToggleSeller] = useState(false)

    const validationArray = Yup.object({
        email: Yup.string().email(t('Invalid email format')).required(t('Required!')),
    })
    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addCustomer(values)
        },
    })
    const { pathname } = useLocation()

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }, 0)
    }, [pathname])

    const authContexts = useContext(AuthContext)
    const { modelStatus } = useContext(commonContext)
    const {
        user,
        isAuthenticated,
        loadPendingCount,
        isAdmin,
        cartCount,
        logout,
        switchUser,
        login,
        responseStatus: responseStatusAuth,
        clearResponse: clearResponseAuth,
    } = authContexts
    const subscribe = [
        {
            label: 'Subscribe to our mailing list',
            placeholder: 'Enter your email address',
            class: 'subsInp',
            type: 'text',
            variant: 'filled',
            name: 'email',
            formik: formik,
        },
    ]

    const changeSellerStatus = () => {
        setToggleSeller(false)
    }

    useEffect(() => {
        if (responseStatusAutoPlt) {
            if (responseStatusAutoPlt.from === 'addCustomer') {
                if (responseStatusAutoPlt.status === 'success') {
                    formik.values.email = ''
                }
            }
        }
    }, [responseStatusAutoPlt])

    const MobileNavsArray = [
        {
            title: 'Home',
            url: '/',
            path: '../assets/svg/home-grey.svg',
            activePath: '../assets/svg/home-grediant.svg',
        },
        {
            title: 'Auction',
            url: '/auctionsList',
            path: '../assets/svg/auction-grey.svg',
            activePath: '../assets/svg/auction-grediant.svg',
        },
        {
            title: 'Search',
            url: '/search',
            path: '../assets/svg/sell-grey.svg',
            activePath: '../assets/svg/sell-grediant.svg',
        },
        {
            title: 'Dashboard',
            url: '/account/dashboard',
            path: '../assets/svg/valuation-grey.svg',
            activePath: '../assets/svg/valuation-grediant.svg',
        },
    ]

    return (
        <>
            <footer className="noPrint">
                <div className="footCnt customContainer">
                    {/* <div className="footLogo">
                    <a className="ASlogo" id="large_logo" href="/">
                        <img
                            src="/assets/images/foot-logo.png"
                            alt="Bond Roberts"
                            width="200"
                            height="40"
                        />
                    </a>
                </div> */}
                    <div className="footLinks">
                        <ul>
                            <li>Legal</li>
                            <li>
                                <Link id="footer_privacy" to="/privacy_policy">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_terms" to="/terms_conditions">
                                    Terms & Condition
                                </Link>
                            </li>
                        </ul>
                        <ul>
                            <li>Company</li>
                            <li>
                                <Link id="footer_about" to="/about_us">
                                    About Us
                                </Link>
                            </li>
                            {/* <li>
                            <Link id="footer_new_equipment" to="/equipment/buy_new_equipment">
                                Buy New Equipment
                            </Link>
                        </li> */}
                            {/* <li>
                            <Link id="footer_used_equipment" to="/equipment/buy_used_equipment">
                                Buy Used Equipment
                            </Link>
                        </li>
                        <li>
                            <Link id="footer_sell_equipment" to="/equipment/sell">
                                Sell Equipment
                            </Link>
                        </li> */}
                            {/* <li>
                            <Link id="footer_insta_valuation" to="/insta_valuation">
                                Insta Valuation
                            </Link>
                        </li>
                        <li>
                            <Link id="footer_advance_valuation" to="/advance_valuation">
                                Advance Valuation
                            </Link>
                        </li>
                        <li>
                            <Link id="footer_finance" to="/finance">
                                Finance
                            </Link>
                        </li> */}
                        </ul>
                        <ul>
                            <li>Popular Items</li>
                            <li>
                                <Link id="footer_auctions" to="/auctionslist">
                                    Auctions
                                </Link>
                            </li>
                            <li onClick={() => window.open(howToReg, '_blank')}>
                                <span>How to Register</span>
                            </li>
                            <li onClick={() => window.open(brochurePDF, '_blank')}>
                                <span>iQuippo&apos;s Brochure</span>
                            </li>
                        </ul>
                        <div className="contactLinkCnt">
                            <div>
                                <ul>
                                    <li style={{ marginBottom: '8px' }}>Social media</li>
                                </ul>

                                <div className="socialMedai">
                                    <a
                                        href=" https://www.facebook.com/iquippo/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src="/assets/svg/fb.svg" alt="Facebook" />
                                    </a>
                                    <a
                                        href="https://www.linkedin.com/company/iquippo/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src="/assets/svg/in.svg" alt="LinkedIn" />
                                    </a>
                                    <a
                                        href="https://twitter.com/IQuippo"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            style={{
                                                width: '54px',
                                                background: '#fff',
                                                padding: '8px',
                                                borderRadius: '5px',
                                            }}
                                            src="/assets/svg/x.svg"
                                            alt="Twitter"
                                        />
                                    </a>
                                    <a
                                        href="https://www.instagram.com/iquippo.official/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src="/assets/svg/ig.svg" alt="Instagram" />
                                    </a>
                                    <a
                                        href="https://www.youtube.com/channel/UCqsEU_H3L_dqY5zuoOkTB-Q"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src="/assets/svg/yt.svg"
                                            alt="YouTube"
                                            width={54}
                                            height={55}
                                        />
                                    </a>
                                </div>
                            </div>
                            <ul style={{ marginTop: '20px' }}>
                                <li>Help</li>
                                <li>
                                    <Link id="footer_contact" to="/contactUs">
                                        Contact Us
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr />
                <p className="footCopyright pb-4" dir="ltr">
                    ©copyright 2020. All rights reserved
                </p>
            </footer>
            {!modelStatus ? (
                <MobileBottomNavigation NavigationText={MobileNavsArray} TextPosition="bottom" />
            ) : null}
        </>
    )
}

export default Footer
